// @ts-nocheck
import { createAsyncActionTypes } from '../../../core/store/actionCreators';

export const FETCH_PRODUCTS = 'product/fetchProducts';
export const {
  pending: FETCH_PRODUCTS_PENDING,
  fulfilled: FETCH_PRODUCTS_FULFILLED,
  rejected: FETCH_PRODUCTS_REJECTED,
} = createAsyncActionTypes(FETCH_PRODUCTS);

export const FETCH_PRODUCT = 'product/fetchProduct';
export const {
  pending: FETCH_PRODUCT_PENDING,
  fulfilled: FETCH_PRODUCT_FULFILLED,
  rejected: FETCH_PRODUCT_REJECTED,
} = createAsyncActionTypes(FETCH_PRODUCT);


export const SELECT_PRODUCT = 'product/selectProduct';

export const DESELECT_PRODUCT = 'product/deselectProduct';

export const FETCH_PRODUCT_CHANGE = 'product/fetchProductChange';
export const {
  pending: FETCH_PRODUCT_CHANGE_PENDING,
  fulfilled: FETCH_PRODUCT_CHANGE_FULFILLED,
  rejected: FETCH_PRODUCT_CHANGE_REJECTED,
} = createAsyncActionTypes(FETCH_PRODUCT_CHANGE);

export const FETCH_PRODUCT_CHANGE_NEXT = 'product/fetchProductChangeNext';
export const {
  pending: FETCH_PRODUCT_CHANGE_NEXT_PENDING,
  fulfilled: FETCH_PRODUCT_CHANGE_NEXT_FULFILLED,
  rejected: FETCH_PRODUCT_CHANGE_NEXT_REJECTED,
} = createAsyncActionTypes(FETCH_PRODUCT_CHANGE_NEXT);

export const CREATE_PRODUCT_CHANGE = 'product/createProductChange';
export const {
  pending: CREATE_PRODUCT_CHANGE_PENDING,
  fulfilled: CREATE_PRODUCT_CHANGE_FULFILLED,
  rejected: CREATE_PRODUCT_CHANGE_REJECTED,
} = createAsyncActionTypes(CREATE_PRODUCT_CHANGE);

export const DELETE_PRODUCT_CHANGE = 'product/deleteProductChange';
export const {
  pending: DELETE_PRODUCT_CHANGE_PENDING,
  fulfilled: DELETE_PRODUCT_CHANGE_FULFILLED,
  rejected: DELETE_PRODUCT_CHANGE_REJECTED,
} = createAsyncActionTypes(DELETE_PRODUCT_CHANGE);
